import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ServiceOrder } from '../serviceOrder.types';
import { ServiceOrderTableRow } from './ServiceOrdersTableRow';
import { ServiceOrdersTableColumns } from './ServiceOrdersTableColumns';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOrderSort, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { Table } from '../../../sharedComponents/table/Table';
import { useSelectedTableColumns } from '../../../sharedComponents/table/useSelectedTableColumns';
import { clientSideFeatureToggles } from '../../../../../configuration/featureToggle/clientSideFeatureToggles';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';

type ServiceOrderTableProps = {
    serviceOrders: ServiceOrder[];
};

export const ServiceOrderTable: FC<ServiceOrderTableProps> = ({ serviceOrders }) => {
    const dispatch = useAppDispatch();
    const sorting = useAppSelector(getServiceOrderSort);
    const showBulk = clientSideFeatureToggles.serviceOrderBulk;

    const setSorting = (newSorting: TableSort<ServiceOrdersTableColumns>) =>
        dispatch(serviceOrdersSlice.actions.setSortingForServiceOrders({ sort: newSorting }));

    const columnDefinition = useSelectedTableColumns<ServiceOrdersTableColumns>();

    return (
        <Table
            columnDefinition={columnDefinition}
            notFoundMessage={<FormattedMessage id="outboundPortal.serviceOrders.notFound" />}
            sorting={sorting}
            setSorting={setSorting}
            items={serviceOrders}
            selectionHeader={showBulk ? <div>FOO</div> : undefined}
        >
            {serviceOrders.map((serviceOrder: ServiceOrder) => (
                <ServiceOrderTableRow
                    key={serviceOrder.id}
                    serviceOrder={serviceOrder}
                    columns={columnDefinition}
                    selectionCell={
                        showBulk ? (
                            <td className="table-checkbox">
                                <Checkbox />
                            </td>
                        ) : undefined
                    }
                />
            ))}
        </Table>
    );
};
